var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFormatPdf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0a.5.5 0 0 1 .492.41L14 .5l-.001 5.499L19.5 6a.5.5 0 0 1 .492.41L20 6.5a.5.5 0 0 1-.41.492L19.5 7h-6a.5.5 0 0 1-.492-.41L13 6.5v-6a.5.5 0 0 1 .5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0H.5a.5.5 0 0 0-.5.5v23a.5.5 0 0 0 .5.5h19a.5.5 0 0 0 .5-.5v-17a.5.5 0 0 0-.146-.354l-6-6A.5.5 0 0 0 13.5 0Zm-.208.999 5.707 5.707v16.293h-18v-22h12.293Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13h-1a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h1c1.454 0 2.5-1.31 2.5-3s-1.046-3-2.5-3Zm-.501 4.999v-4L10.5 14c.846 0 1.5.82 1.5 2 0 1.18-.654 2-1.5 2l-.501-.001ZM17 13a.5.5 0 0 1 .09.992L17 14l-2.001-.001L15 18.5a.5.5 0 0 1-.41.492L14.5 19a.5.5 0 0 1-.492-.41L14 18.5v-5a.5.5 0 0 1 .41-.492L14.5 13H17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15a.5.5 0 0 1 .09.992L16 16h-1.5a.5.5 0 0 1-.09-.992L14.5 15H16ZM5.75 13a1.75 1.75 0 0 1 .143 3.494l-.143.006-.751-.001.001 2a.5.5 0 0 1-.41.492l-.09.008a.5.5 0 0 1-.492-.41L4 18.499V13.5a.5.5 0 0 1 .41-.492L4.5 13h1.25Zm-.751 2.499.751.001a.751.751 0 0 0 .102-1.493L5.75 14l-.751-.001v1.5Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFormatPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/format-pdf.49d59abdcdcb4a5b418214de8866039a.svg";